import { render, staticRenderFns } from "./eventDialog.vue?vue&type=template&id=3121bbd9&"
import script from "./eventDialog.vue?vue&type=script&lang=js&"
export * from "./eventDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports